import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useContext, useState } from "react";
import PurchaseTicketApi from "../../api/purchase-ticket";
import Customer from "../../types/customer";
import PurchaseTicket from "../../types/purchase-ticket";
import AuthContext from "../auth-context";
import AvatarImage from "../avatar-image";
import CartMenuItem from "./cart-menu-item";
import ServicesDropdown from "./services-dropdown";
import ShoppingCardItem from "./shopping-card-item";
import NavbarBrand from "../../components/tailwind/navbar-brand";
import NavbarToggle from "../tailwind/navbar-toggle";
import Dropdown from "../tailwind/dropdown";
import Nav from "../tailwind/nav";
import NavbarCollapse from "../tailwind/navbar-collapse";
import DropdownspanToggle from "../tailwind/span-toggle";

export interface NavbarProps {
  customer: Customer;
  isCollapsed: boolean;
  onCollapse: (isCollapsed: boolean) => void;
  isVisible: boolean;
  onShow: (isVisible: boolean) => void;
  openTickes: PurchaseTicket[];
  onTicketChange: () => void;
}

function Navbar({
  customer,
  isCollapsed,
  onCollapse,
  isVisible,
  onShow,
  openTickes,
  onTicketChange,
}: NavbarProps) {
  const context = useContext(AuthContext);
  const [toggle, setToggle] = useState(false);

  return (
    <div className="navbar-sm navbar-fixed navbar-white2">
      <div className="navbar-inner shadow-md">
        <div id="btn-burger" className="d-flex h-100 justify-content-xl-between align-items-center">
          <button
            type="button"
            className={`btn btn-burger  ml-2 ${isVisible ? "collapsed" : ""}`}
            aria-controls="sidebar"
            aria-label="Toggle sidebar"
            onClick={() => onShow(!isVisible)}
          >
            <span className="bars text-grey-m2"></span>
          </button>

          <NavbarBrand className="d-xl-none mx-1 text-grey-d3 text-130">
            <img
              alt="logo"
              className="logo mobile"
              src="https://c.sepanta.com/i1/Logos/SepantaLogo.png"
              style={{ height: "35px" }}
            />
            <span className="mainTitle">سپنتا</span>
            <small>
              <span className="d-sm-inline-block subTitle">(اینترنت)</span>
            </small>
          </NavbarBrand>

          <button
            type="button"
            className={`btn text-grey-m2 btn-burger hidden xl:flex align-self-center mx-2 btn-h-light-primary ${
              isCollapsed ? "collapsed" : ""
            }`}
            aria-controls="sidebar"
            aria-label="Toggle sidebar"
            onClick={() => onCollapse(!isCollapsed)}
          >
            <span className="bars"></span>
          </button>
        </div>

        <ServicesDropdown />

        <NavbarToggle
          className="ml-1 mr-2 px-1"
          aria-controls="navbarMenu"
          aria-expanded={toggle}
          aria-label="Toggle navbar menu"
          onClick={() => setToggle((prev) => !prev)}
        >
          <AvatarImage
            customer={customer}
            width={36}
            className="p-1px brc-primary-tp3 mx-0"
          />
        </NavbarToggle>

        <NavbarCollapse
          className={`navbar-menu ${toggle ? "show" : ""} navbar-backdrop`}
        >
          <Nav className="navbar-nav">
            <ul className="nav has-active-border">
              <ShoppingCardItem>
                {openTickes.map((t) => (
                  <CartMenuItem
                    key={t.id}
                    type={t.type}
                    titles={t.titles}
                    id={t.id}
                    onCancel={() => {
                      const purchaseTicketApi = new PurchaseTicketApi(context);
                      purchaseTicketApi.delete(t.id);
                      onTicketChange();
                    }}
                  />
                ))}
              </ShoppingCardItem>
              <Dropdown className="nav-item dropdown-mega">
                <DropdownspanToggle className="nav-link pl-lg-3 pr-lg-4">
                  <FontAwesomeIcon icon="bell" className="text-110 mr-lg-2" />
                  <span className="d-inline-block d-lg-none ml-2">
                    اعلان‌ها
                  </span>
                  <FontAwesomeIcon
                    icon="angle-right"
                    className="caret d-block d-lg-none"
                  />
                </DropdownspanToggle>
              </Dropdown>
            </ul>
          </Nav>
        </NavbarCollapse>
      </div>
    </div>
  );
}

export default Navbar;
